/**
 * orga-app-api - veranstaltungen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FunktionsbereichOkNotification { 
    titel?: string;
    text?: string;
    data?: { [key: string]: string; };
    funktionsbereich_id: string;
    funktionsbereich_titel: string;
    mandant_id: string;
    veranstaltung_id: string;
    veranstaltung_titel?: string;
    notification_type?: string;
}

